import { render, staticRenderFns } from "./consequence.vue?vue&type=template&id=57088f4b&scoped=true&"
var script = {}
import style0 from "./consequence.vue?vue&type=style&index=0&id=57088f4b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57088f4b",
  null
  
)

export default component.exports